const TipeStafSearchCategories = ["id_tipe_staf", "nama_tipe_staf"];

export default TipeStafSearchCategories;
